import { useMutation } from '@tanstack/react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';
import { enableSmsSoleProprietor } from 'services';
import { useSnackbar } from 'hooks';

const errorMessage = 'Something went wrong, please try again later.';
export function useEnableSmsSP() {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr = globalStoreData.user?.profileDTO?.corpAcctNbr;
  const setSnackbar = useSnackbar();

  return useMutation({
    mutationFn: (phoneNumber: string) =>
      enableSmsSoleProprietor(corpAcctNbr, phoneNumber),
    onSuccess: () => {
      setSnackbar({
        message: 'SMS enablement succeeded.',
        severity: 'success',
      });
    },
    onError: (error) => {
      const errorResponse = error as {
        response?: { data?: { displayMessage?: string } };
      };
      setSnackbar({
        message: errorResponse?.response?.data?.displayMessage || errorMessage,
        severity: 'error',
      });
    },
  });
}
